// import { initializeApp, getApp, getApps, FirebaseApp } from "firebase/app";
// import {
//   getAuth,
//   setPersistence,
//   browserLocalPersistence,
//   Auth,
//   GoogleAuthProvider,
//   signInWithPopup,
//   UserCredential,
// } from "firebase/auth";

// import {
//   getMessaging,
//   getToken,
//   onMessage,
//   Messaging,
// } from "firebase/messaging";

// // Firebase configuration (from .env)
// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "",
//   authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "",
//   projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "",
//   storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "",
//   messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "",
//   appId: process.env.REACT_APP_FIREBASE_APP_ID || "",
//   // vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY || "", // TODO: Add VAPID key for notifications
// };

// // Validate Firebase configuration
// const validateFirebaseConfig = (config: Record<string, string>) => {
//   for (const [key, value] of Object.entries(config)) {
//     if (!value) {
//       console.error(`Missing Firebase config key: ${key}`);
//       throw new Error(`Firebase configuration is invalid. Missing: ${key}`);
//     }
//   }
// };
// validateFirebaseConfig(firebaseConfig);

// // Ensure Firebase is initialized only once
// class Firebase {
//   private static instance: Firebase;
//   public app: FirebaseApp;
//   public auth: Auth;
//   public messaging: Messaging | null = null;
//   private messagingInstancePromise: Promise<Messaging | null> | null = null;

//   private constructor() {
//     this.app = getApps().length ? getApp() : initializeApp(firebaseConfig);
//     this.auth = getAuth(this.app);

//     // // Service Worker Registration
//     // if ("serviceWorker" in navigator) {
//     //   try {
//     //     navigator.serviceWorker
//     //       .register("/firebase-messaging-sw.js")
//     //       .then((registration) => {
//     //         console.log(
//     //           "Service Worker registered successfully:",
//     //           registration
//     //         );
//     //       })
//     //       .catch((error) => {
//     //         console.error("Service Worker registration failed:", error);
//     //       });
//     //   } catch (error) {
//     //     console.error("Service Worker registration error:", error);
//     //   }
//     // ✅ Service Worker Registration (Ensure it's only registered once)
//     if ("serviceWorker" in navigator) {
//       navigator.serviceWorker
//         .register("/firebase-messaging-sw.js")
//         .then((registration) => {
//           console.log(
//             "✅ Service Worker registered successfully:",
//             registration
//           );
//         })
//         .catch((error) => {
//           console.error("❌ Service Worker registration failed:", error);
//         });
//     }

//     // Save Firebase config to IndexedDB for secure access in the Service Worker
//     this.saveConfigToIndexedDB();
//   }

//   // Get the singleton instance
//   public static getInstance(): Firebase {
//     if (!Firebase.instance) {
//       Firebase.instance = new Firebase();
//     }
//     return Firebase.instance;
//   }

//   // Ensure messaging is initialized before use
//   public async getMessagingInstance(): Promise<Messaging | null> {
//     if (this.messaging) return this.messaging;

//     if (!this.messagingInstancePromise) {
//       this.messagingInstancePromise = import("firebase/messaging").then(
//         ({ getMessaging }) => {
//           this.messaging = getMessaging(this.app);
//           return this.messaging;
//         }
//       );
//     }

//     return this.messagingInstancePromise;
//   }

//   /**
//    * Save Firebase config to IndexedDB securely for Service Worker access.
//    */
//   private saveConfigToIndexedDB() {
//     if (!("indexedDB" in window)) {
//       console.warn("IndexedDB is not supported in this browser.");
//       return;
//     }

//     const request = indexedDB.open("firebaseDB", 1);

//     request.onupgradeneeded = (event) => {
//       const db = request.result;
//       if (!db.objectStoreNames.contains("config")) {
//         db.createObjectStore("config", { keyPath: "id" });
//       }
//     };

//     request.onsuccess = () => {
//       const db = request.result;
//       const transaction = db.transaction("config", "readwrite");
//       const store = transaction.objectStore("config");
//       store.put({ id: "firebaseConfig", ...firebaseConfig });

//       transaction.oncomplete = () => {
//         console.log("Firebase config successfully saved to IndexedDB.");
//       };
//     };

//     request.onerror = (event) => {
//       console.error("Error opening IndexedDB:", event);
//     };
//   }
// }

// // Export the singleton instance
// const firebaseInstance = Firebase.getInstance();

// // Setup authentication persistence
// setPersistence(firebaseInstance.auth, browserLocalPersistence).catch((error) =>
//   console.error("Error setting auth persistence:", error)
// );

// export const auth = firebaseInstance.auth;
// export const googleProvider = new GoogleAuthProvider();

// /**
//  * Sign in with Google using Firebase Authentication.
//  * @returns {Promise<UserCredential | null>} The user credential on successful login.
//  */
// export const signInWithGoogle = async (): Promise<UserCredential | null> => {
//   try {
//     const result = await signInWithPopup(auth, googleProvider);
//     console.log("User signed in:", result.user);
//     return result;
//   } catch (error) {
//     console.error("Google Sign-In Error:", error);
//     return null;
//   }
// };
// // TODO: Revert back for notifications
// /**
//  * Request notification permission and get FCM token.
//  * @returns {Promise<string | null>} The FCM token if permission is granted.
//  */
// // export const getFcmToken = async (): Promise<string | null> => {
// //   try {
// //     // ✅ Request permission properly
// //     const permission = await Notification.requestPermission();
// //     if (permission !== "granted") {
// //       console.warn("⚠️ Notification permission denied.");
// //       return null;
// //     }

// //     // ✅ Ensure Firebase Messaging is initialized
// //     const messaging = await firebaseInstance.getMessagingInstance();
// //     if (!messaging) {
// //       console.error("❌ Firebase Messaging is not initialized yet.");
// //       return null;
// //     }

// //     // ✅ Ensure Service Worker is registered before getting the token
// //     let registration;
// //     try {
// //       registration = await navigator.serviceWorker.ready;
// //     } catch (error) {
// //       console.error("❌ Service worker not ready:", error);
// //       return null;
// //     }

// //     // ✅ Get the FCM token
// //     const token = await getToken(messaging, {
// //       vapidKey: firebaseConfig.vapidKey, // Ensure VAPID key is set correctly
// //       serviceWorkerRegistration: registration,
// //     });

// //     if (!token) {
// //       console.warn("⚠️ No FCM token received.");
// //       return null;
// //     }

// //     console.log("✅ FCM Token:", token);
// //     return token;
// //   } catch (error) {
// //     console.error("❌ Error getting FCM token:", error);
// //     return null;
// //   }
// // };

// // /**
// //  * Handle incoming foreground notifications.
// //  */
// // firebaseInstance.getMessagingInstance().then((messaging) => {
// //   if (messaging) {
// //     onMessage(messaging, (payload) => {
// //       console.log("📢 Foreground notification received:", payload);

// //       if (Notification.permission === "granted") {
// //         new Notification(payload.notification?.title || "New Notification", {
// //           body: payload.notification?.body || "You have a new message",
// //           icon: payload.notification?.image || "/firebase-logo.png",
// //         });
// //       } else {
// //         console.warn("⚠️ Notification permission not granted.");
// //       }
// //     });
// //   }
// // });

// export default firebaseInstance;

// 2nd last chnage

// import { initializeApp, getApp, getApps, FirebaseApp } from "firebase/app";
// import {
//   getAuth,
//   setPersistence,
//   browserLocalPersistence,
//   Auth,
//   GoogleAuthProvider,
//   signInWithPopup,
//   UserCredential,
// } from "firebase/auth";

// import {
//   getMessaging,
//   getToken,
//   onMessage,
//   Messaging,
// } from "firebase/messaging";

// // Firebase configuration (from .env)
// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "",
//   authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "",
//   projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "",
//   storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "",
//   messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "",
//   appId: process.env.REACT_APP_FIREBASE_APP_ID || "",
//   // vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY || "", // TODO: Add VAPID key for notifications
// };

// // Validate Firebase configuration
// const validateFirebaseConfig = (config: Record<string, string>) => {
//   for (const [key, value] of Object.entries(config)) {
//     if (!value) {
//       console.error(`Missing Firebase config key: ${key}`);
//       throw new Error(`Firebase configuration is invalid. Missing: ${key}`);
//     }
//   }
// };
// validateFirebaseConfig(firebaseConfig);

// // Ensure Firebase is initialized only once
// class Firebase {
//   private static instance: Firebase;
//   public app: FirebaseApp;
//   public auth: Auth;
//   public messaging: Messaging | null = null;
//   private messagingInstancePromise: Promise<Messaging | null> | null = null;
//   private fingerPrintingInitialized: boolean = false;

//   private constructor() {
//     this.app = getApps().length ? getApp() : initializeApp(firebaseConfig);
//     this.auth = getAuth(this.app);

//     // Service Worker Registration
//     if ("serviceWorker" in navigator) {
//       navigator.serviceWorker
//         .register("/firebase-messaging-sw.js")
//         .then((registration) => {
//           console.log(
//             "✅ Service Worker registered successfully:",
//             registration
//           );
//         })
//         .catch((error) => {
//           console.error("❌ Service Worker registration failed:", error);
//         });
//     }

//     // Save Firebase config to IndexedDB for secure access in the Service Worker
//     this.saveConfigToIndexedDB();

//     // Set up device recognition to help reduce reCAPTCHA challenges
//     this.setupBrowserFingerprinting();

//     // Apply Apple-specific optimizations
//     this.setupAppleDeviceOptimizations();
//   }

//   // Get the singleton instance
//   public static getInstance(): Firebase {
//     if (!Firebase.instance) {
//       Firebase.instance = new Firebase();
//     }
//     return Firebase.instance;
//   }

//   // Ensure messaging is initialized before use
//   public async getMessagingInstance(): Promise<Messaging | null> {
//     if (this.messaging) return this.messaging;

//     if (!this.messagingInstancePromise) {
//       this.messagingInstancePromise = import("firebase/messaging").then(
//         ({ getMessaging }) => {
//           this.messaging = getMessaging(this.app);
//           return this.messaging;
//         }
//       );
//     }

//     return this.messagingInstancePromise;
//   }

//   /**
//    * Save Firebase config to IndexedDB securely for Service Worker access.
//    */
//   private saveConfigToIndexedDB() {
//     if (!("indexedDB" in window)) {
//       console.warn("IndexedDB is not supported in this browser.");
//       return;
//     }

//     const request = indexedDB.open("firebaseDB", 1);

//     request.onupgradeneeded = (event) => {
//       const db = request.result;
//       if (!db.objectStoreNames.contains("config")) {
//         db.createObjectStore("config", { keyPath: "id" });
//       }
//     };

//     request.onsuccess = () => {
//       const db = request.result;
//       const transaction = db.transaction("config", "readwrite");
//       const store = transaction.objectStore("config");
//       store.put({ id: "firebaseConfig", ...firebaseConfig });

//       transaction.oncomplete = () => {};
//     };

//     request.onerror = (event) => {
//       console.error("Error opening IndexedDB:", event);
//     };
//   }

//   /**
//    * Set up browser fingerprinting to help Google recognize returning users
//    * This reduces the likelihood of reCAPTCHA challenges for returning visitors
//    */
//   public setupBrowserFingerprinting() {
//     if (this.fingerPrintingInitialized) {
//       return; // Avoid initializing multiple times
//     }

//     try {
//       // First-party cookie for returning user recognition
//       document.cookie =
//         "returning_user=true; path=/; max-age=31536000; SameSite=Strict"; // 1 year

//       // Store app information in localStorage (helps with device recognition)
//       localStorage.setItem("app_version", "1.0.0");
//       localStorage.setItem("device_initialized", new Date().toISOString());

//       // Simple browser fingerprint (non-unique, just helps with recognition)
//       const browserInfo = {
//         userAgent: navigator.userAgent,
//         language: navigator.language,
//         platform: navigator.platform,
//         screenWidth: window.screen.width,
//         screenHeight: window.screen.height,
//         timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
//         lastVisit: new Date().toISOString(),
//       };

//       // Store a simplified version for recognition patterns
//       localStorage.setItem(
//         "browser_info",
//         JSON.stringify({
//           lang: browserInfo.language,
//           tz: browserInfo.timeZone,
//           screen: `${browserInfo.screenWidth}x${browserInfo.screenHeight}`,
//           last: browserInfo.lastVisit,
//         })
//       );

//       // Mark as initialized
//       this.fingerPrintingInitialized = true;
//     } catch (e) {
//       console.warn("Could not set up browser fingerprinting", e);
//     }
//   }

//   /**
//    * Detects if the user is on an Apple device and applies specific optimizations
//    */
//   private setupAppleDeviceOptimizations() {
//     const isAppleDevice = /iPhone|iPad|iPod|Mac/.test(navigator.userAgent);

//     if (isAppleDevice) {
//       try {
//         // For Apple devices, we need to use localStorage more aggressively
//         // since cookies are more restricted
//         localStorage.setItem("device_type", "apple");

//         // Use sessionStorage instead of cookies for session tracking on Apple devices
//         sessionStorage.setItem("session_start", new Date().toISOString());

//         // Set a flag to identify this as an authenticated session
//         if (this.auth.currentUser) {
//           sessionStorage.setItem("auth_session", "true");
//         }
//       } catch (e) {
//         console.warn("Could not apply Apple device optimizations", e);
//       }
//     }
//   }

//   /**
//    * Update the last visit timestamp for returning users
//    * Call this method when user successfully authenticates
//    */
//   public recordSuccessfulAuth(method: string, phoneOrEmail: string): void {
//     try {
//       // Update last visit time
//       const browserInfo = localStorage.getItem("browser_info");
//       if (browserInfo) {
//         const info = JSON.parse(browserInfo);
//         info.last = new Date().toISOString();
//         localStorage.setItem("browser_info", JSON.stringify(info));
//       }

//       // Store masked auth info to help with recognition
//       // Only store the first 2 chars and last 2 chars of phone/email for privacy
//       if (phoneOrEmail && phoneOrEmail.length > 4) {
//         const mask =
//           phoneOrEmail.substring(0, 2) +
//           "..." +
//           phoneOrEmail.substring(phoneOrEmail.length - 2);

//         localStorage.setItem("auth_user", mask);
//         localStorage.setItem("auth_method", method);
//         localStorage.setItem("auth_success", "true");
//         localStorage.setItem("auth_last", new Date().toISOString());
//       }

//       // Increment login count
//       let loginCount = parseInt(localStorage.getItem("login_count") || "0");
//       localStorage.setItem("login_count", (loginCount + 1).toString());
//     } catch (e) {
//       console.warn("Could not record successful auth", e);
//     }
//   }
// }

// // Export the singleton instance
// const firebaseInstance = Firebase.getInstance();

// // Setup authentication persistence
// setPersistence(firebaseInstance.auth, browserLocalPersistence).catch((error) =>
//   console.error("Error setting auth persistence:", error)
// );

// export const auth = firebaseInstance.auth;
// export const googleProvider = new GoogleAuthProvider();

// /**
//  * Sign in with Google using Firebase Authentication.
//  * @returns {Promise<UserCredential | null>} The user credential on successful login.
//  */
// export const signInWithGoogle = async (): Promise<UserCredential | null> => {
//   try {
//     const result = await signInWithPopup(auth, googleProvider);

//     // Record successful Google auth for device recognition
//     if (result.user?.email) {
//       firebaseInstance.recordSuccessfulAuth("google", result.user.email);
//     }

//     return result;
//   } catch (error) {
//     console.error("Google Sign-In Error:", error);
//     return null;
//   }
// };

// /**
//  * Records successful phone authentication for device recognition
//  * @param phoneNumber The phone number that was authenticated
//  */
// export const recordPhoneAuthSuccess = (phoneNumber: string): void => {
//   firebaseInstance.recordSuccessfulAuth("phone", phoneNumber);
// };

// export default firebaseInstance;

import { initializeApp, getApp, getApps, FirebaseApp } from "firebase/app";
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
  Auth,
  GoogleAuthProvider,
  signInWithPopup,
  UserCredential,
} from "firebase/auth";

import {
  getMessaging,
  getToken,
  onMessage,
  Messaging,
} from "firebase/messaging";

// Firebase configuration (from .env)
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "",
  // reCAPTCHA Enterprise configuration
  recaptchaEnterpriseConfig: {
    siteKey: process.env.REACT_APP_RECAPTCHA_ENTERPRISE_SITE_KEY || "",
    // Enable enterprise features
    useEnterprise: true,
  },
};

// Validate Firebase configuration
const validateFirebaseConfig = (config: Record<string, any>) => {
  const requiredKeys = [
    "apiKey",
    "authDomain",
    "projectId",
    "storageBucket",
    "messagingSenderId",
    "appId",
  ];

  for (const key of requiredKeys) {
    if (!config[key]) {
      console.error(`Missing Firebase config key: ${key}`);
      throw new Error(`Firebase configuration is invalid. Missing: ${key}`);
    }
  }

  // Warn if reCAPTCHA Enterprise site key is missing
  if (!config.recaptchaEnterpriseConfig?.siteKey) {
    console.warn(
      "⚠️ reCAPTCHA Enterprise site key is missing. Using fallback configuration."
    );
  }
};
validateFirebaseConfig(firebaseConfig);

// Enhanced browser fingerprinting for better trust signals
const generateEnhancedFingerprint = () => {
  try {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    ctx?.fillText("Trust signal", 2, 2);

    return {
      userAgent: navigator.userAgent,
      language: navigator.language,
      languages: navigator.languages?.join(",") || "",
      platform: navigator.platform,
      screenWidth: window.screen.width,
      screenHeight: window.screen.height,
      screenDepth: window.screen.colorDepth,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      canvasFingerprint: canvas.toDataURL().slice(-50), // Last 50 chars for privacy
      hardwareConcurrency: navigator.hardwareConcurrency || 0,
      deviceMemory: (navigator as any).deviceMemory || 0,
      cookieEnabled: navigator.cookieEnabled,
      doNotTrack: navigator.doNotTrack,
      webGL: getWebGLInfo(),
      lastVisit: new Date().toISOString(),
    };
  } catch (e) {
    console.warn("Could not generate enhanced fingerprint:", e);
    return null;
  }
};

const getWebGLInfo = () => {
  try {
    const canvas = document.createElement("canvas");
    const gl =
      canvas.getContext("webgl") ||
      (canvas.getContext("experimental-webgl") as WebGLRenderingContext);
    if (!gl) return null;

    return {
      vendor: gl.getParameter(gl.VENDOR),
      renderer: gl.getParameter(gl.RENDERER),
    };
  } catch (e) {
    return null;
  }
};

// Ensure Firebase is initialized only once
class Firebase {
  private static instance: Firebase;
  public app: FirebaseApp;
  public auth: Auth;
  public messaging: Messaging | null = null;
  private messagingInstancePromise: Promise<Messaging | null> | null = null;
  private fingerPrintingInitialized: boolean = false;
  private trustSignalsInitialized: boolean = false;

  private constructor() {
    this.app = getApps().length ? getApp() : initializeApp(firebaseConfig);
    this.auth = getAuth(this.app);

    // Enhanced Service Worker Registration with Enterprise support
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .then((registration) => {
          // Inject reCAPTCHA Enterprise configuration into service worker
          this.configureServiceWorkerForEnterprise(registration);
        })
        .catch((error) => {
          console.error("❌ Service Worker registration failed:", error);
        });
    }

    // Save Firebase config to IndexedDB for secure access in the Service Worker
    this.saveConfigToIndexedDB();

    // Set up enhanced device recognition and trust signals
    this.setupEnhancedBrowserFingerprinting();
    this.setupTrustSignals();

    // Apply device-specific optimizations
    this.setupDeviceOptimizations();

    // Initialize domain verification
    this.initializeDomainVerification();
  }

  // Get the singleton instance
  public static getInstance(): Firebase {
    if (!Firebase.instance) {
      Firebase.instance = new Firebase();
    }
    return Firebase.instance;
  }

  // Configure Service Worker for reCAPTCHA Enterprise
  private configureServiceWorkerForEnterprise(
    registration: ServiceWorkerRegistration
  ) {
    try {
      if (registration.active) {
        registration.active.postMessage({
          type: "RECAPTCHA_ENTERPRISE_CONFIG",
          config: {
            siteKey: firebaseConfig.recaptchaEnterpriseConfig?.siteKey,
            domain: window.location.hostname,
            useEnterprise: true,
          },
        });
      }
    } catch (e) {
      console.warn("Could not configure service worker for enterprise:", e);
    }
  }

  // Initialize domain verification for reCAPTCHA Enterprise
  private initializeDomainVerification() {
    try {
      // Add domain verification meta tag for better trust
      const existingMeta = document.querySelector(
        'meta[name="recaptcha-site-verification"]'
      );
      if (!existingMeta && firebaseConfig.recaptchaEnterpriseConfig?.siteKey) {
        const meta = document.createElement("meta");
        meta.name = "recaptcha-site-verification";
        meta.content = firebaseConfig.recaptchaEnterpriseConfig.siteKey;
        document.head.appendChild(meta);
      }

      // Set domain-specific localStorage markers
      localStorage.setItem("domain_verified", window.location.hostname);
      localStorage.setItem(
        "domain_verification_time",
        new Date().toISOString()
      );
    } catch (e) {
      console.warn("Could not initialize domain verification:", e);
    }
  }

  // Ensure messaging is initialized before use
  public async getMessagingInstance(): Promise<Messaging | null> {
    if (this.messaging) return this.messaging;

    if (!this.messagingInstancePromise) {
      this.messagingInstancePromise = import("firebase/messaging").then(
        ({ getMessaging }) => {
          this.messaging = getMessaging(this.app);
          return this.messaging;
        }
      );
    }

    return this.messagingInstancePromise;
  }

  /**
   * Save Firebase config to IndexedDB securely for Service Worker access.
   */
  private saveConfigToIndexedDB() {
    if (!("indexedDB" in window)) {
      console.warn("IndexedDB is not supported in this browser.");
      return;
    }

    const request = indexedDB.open("firebaseDB", 2); // Increment version for new schema

    request.onupgradeneeded = (event) => {
      const db = request.result;

      // Create config store if it doesn't exist
      if (!db.objectStoreNames.contains("config")) {
        db.createObjectStore("config", { keyPath: "id" });
      }

      // Create trust signals store
      if (!db.objectStoreNames.contains("trustSignals")) {
        db.createObjectStore("trustSignals", { keyPath: "id" });
      }
    };

    request.onsuccess = () => {
      const db = request.result;
      const transaction = db.transaction(
        ["config", "trustSignals"],
        "readwrite"
      );

      // Store Firebase config
      const configStore = transaction.objectStore("config");
      configStore.put({ id: "firebaseConfig", ...firebaseConfig });

      // Store enhanced trust signals
      const trustStore = transaction.objectStore("trustSignals");
      const fingerprint = generateEnhancedFingerprint();
      if (fingerprint) {
        trustStore.put({ id: "deviceFingerprint", ...fingerprint });
      }

      transaction.oncomplete = () => {};
    };

    request.onerror = (event) => {
      console.error("Error opening IndexedDB:", event);
    };
  }

  /**
   * Enhanced browser fingerprinting with better trust signals for reCAPTCHA Enterprise
   */
  public setupEnhancedBrowserFingerprinting() {
    if (this.fingerPrintingInitialized) {
      return;
    }

    try {
      // Enhanced cookie strategy with SameSite=None for cross-site compatibility
      const cookieOptions = [
        "returning_user=true",
        "path=/",
        "max-age=31536000", // 1 year
        "SameSite=Strict",
        "Secure", // HTTPS only
      ].join("; ");

      document.cookie = cookieOptions;

      // Enhanced localStorage with more trust signals
      const trustData = {
        app_version: "1.0.0",
        device_initialized: new Date().toISOString(),
        domain: window.location.hostname,
        session_count: (
          parseInt(localStorage.getItem("session_count") || "0") + 1
        ).toString(),
        last_successful_action:
          localStorage.getItem("last_successful_action") || "none",
        user_interaction_score: this.calculateUserInteractionScore(),
        enterprise_verified: "true",
      };

      Object.entries(trustData).forEach(([key, value]) => {
        localStorage.setItem(key, value);
      });

      // Enhanced fingerprint with more data points
      const enhancedFingerprint = generateEnhancedFingerprint();
      if (enhancedFingerprint) {
        localStorage.setItem(
          "enhanced_fingerprint",
          JSON.stringify(enhancedFingerprint)
        );
      }

      this.fingerPrintingInitialized = true;
    } catch (e) {
      console.warn("Could not set up enhanced browser fingerprinting:", e);
    }
  }

  /**
   * Calculate user interaction score for better trust signals
   */
  private calculateUserInteractionScore(): string {
    try {
      let score = 0;

      // Previous successful logins
      const loginCount = parseInt(localStorage.getItem("login_count") || "0");
      score += Math.min(loginCount * 10, 50); // Max 50 points for login history

      // Time spent on domain
      const firstVisit = localStorage.getItem("first_visit_time");
      if (firstVisit) {
        const daysSinceFirst =
          (Date.now() - new Date(firstVisit).getTime()) / (1000 * 60 * 60 * 24);
        score += Math.min(daysSinceFirst * 2, 30); // Max 30 points for domain familiarity
      } else {
        localStorage.setItem("first_visit_time", new Date().toISOString());
      }

      // Successful verifications
      const verifyCount = parseInt(
        localStorage.getItem("otp_verify_count") || "0"
      );
      score += Math.min(verifyCount * 5, 20); // Max 20 points for verification history

      return Math.min(score, 100).toString(); // Cap at 100
    } catch (e) {
      return "0";
    }
  }

  /**
   * Set up additional trust signals for reCAPTCHA Enterprise
   */
  private setupTrustSignals() {
    if (this.trustSignalsInitialized) return;

    try {
      // Mouse movement tracking for human behavior signals
      let mouseMovements = 0;
      const handleMouseMove = () => {
        mouseMovements++;
        if (mouseMovements > 10) {
          localStorage.setItem("human_behavior_detected", "true");
          localStorage.setItem("last_interaction", new Date().toISOString());
          document.removeEventListener("mousemove", handleMouseMove);
        }
      };
      document.addEventListener("mousemove", handleMouseMove);

      // Touch/click interaction tracking
      let interactions = 0;
      const handleInteraction = () => {
        interactions++;
        localStorage.setItem("interaction_count", interactions.toString());
        localStorage.setItem("last_user_action", new Date().toISOString());
      };

      ["click", "touchstart", "keydown"].forEach((event) => {
        document.addEventListener(event, handleInteraction, { once: true });
      });

      // Page visibility tracking
      document.addEventListener("visibilitychange", () => {
        if (document.hidden) {
          localStorage.setItem(
            "page_hidden_count",
            (
              parseInt(localStorage.getItem("page_hidden_count") || "0") + 1
            ).toString()
          );
        } else {
          localStorage.setItem("page_focus_time", new Date().toISOString());
        }
      });

      this.trustSignalsInitialized = true;
    } catch (e) {
      console.warn("Could not set up trust signals:", e);
    }
  }

  /**
   * Device-specific optimizations for different browsers/platforms
   */
  private setupDeviceOptimizations() {
    const isAppleDevice = /iPhone|iPad|iPod|Mac/.test(navigator.userAgent);
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const isChrome = /Chrome/.test(navigator.userAgent);
    const isFirefox = /Firefox/.test(navigator.userAgent);

    try {
      // Apple device optimizations
      if (isAppleDevice || isSafari) {
        localStorage.setItem("device_type", "apple");
        localStorage.setItem("browser_type", "safari");

        // Safari-specific trust signals
        sessionStorage.setItem("safari_session", "true");
        sessionStorage.setItem(
          "webkit_version",
          navigator.userAgent.match(/WebKit\/(\d+)/)?.[1] || "unknown"
        );

        // Disable tracking prevention warnings in console
      }

      // Chrome optimizations
      if (isChrome) {
        localStorage.setItem("browser_type", "chrome");
        localStorage.setItem("chrome_optimized", "true");
      }

      // Firefox optimizations
      if (isFirefox) {
        localStorage.setItem("browser_type", "firefox");
        localStorage.setItem("firefox_optimized", "true");
      }

      // Mobile device detection and optimization
      const isMobile =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        );
      if (isMobile) {
        localStorage.setItem("device_category", "mobile");
        localStorage.setItem("mobile_optimized", "true");

        // Mobile-specific trust signals
        if ("orientation" in window) {
          localStorage.setItem("orientation_support", "true");
        }
        if ("ontouchstart" in window) {
          localStorage.setItem("touch_support", "true");
        }
      } else {
        localStorage.setItem("device_category", "desktop");
      }

      // Network information if available
      if ("connection" in navigator) {
        const connection = (navigator as any).connection;
        localStorage.setItem(
          "network_type",
          connection.effectiveType || "unknown"
        );
      }
    } catch (e) {
      console.warn("Could not apply device optimizations:", e);
    }
  }

  /**
   * Record successful authentication with enhanced tracking
   */
  public recordSuccessfulAuth(method: string, phoneOrEmail: string): void {
    try {
      // Update interaction score
      const currentScore = parseInt(
        localStorage.getItem("user_interaction_score") || "0"
      );
      localStorage.setItem(
        "user_interaction_score",
        (currentScore + 25).toString()
      );

      // Update last visit time with enhanced data
      const enhancedFingerprint = localStorage.getItem("enhanced_fingerprint");
      if (enhancedFingerprint) {
        const fingerprint = JSON.parse(enhancedFingerprint);
        fingerprint.lastVisit = new Date().toISOString();
        fingerprint.lastAuthMethod = method;
        localStorage.setItem(
          "enhanced_fingerprint",
          JSON.stringify(fingerprint)
        );
      }

      // Store masked auth info for recognition (privacy-safe)
      let mask = "";
      if (phoneOrEmail && phoneOrEmail.length > 4) {
        mask =
          phoneOrEmail.substring(0, 2) +
          "..." +
          phoneOrEmail.substring(phoneOrEmail.length - 2);
        localStorage.setItem("auth_user_masked", mask);
        localStorage.setItem("auth_method", method);
        localStorage.setItem("auth_success", "true");
        localStorage.setItem("auth_last", new Date().toISOString());
      }

      // Enhanced login tracking
      const loginCount =
        parseInt(localStorage.getItem("login_count") || "0") + 1;
      localStorage.setItem("login_count", loginCount.toString());
      localStorage.setItem("last_successful_action", "authentication");

      // Track consecutive successful logins for trust building
      const consecutiveLogins =
        parseInt(localStorage.getItem("consecutive_successful_logins") || "0") +
        1;
      localStorage.setItem(
        "consecutive_successful_logins",
        consecutiveLogins.toString()
      );

      // Enterprise-specific success markers
      localStorage.setItem("enterprise_auth_verified", "true");
      localStorage.setItem(
        "domain_trust_level",
        Math.min(loginCount * 5, 100).toString()
      );
    } catch (e) {
      console.warn("Could not record enhanced auth success:", e);
    }
  }

  /**
   * Get reCAPTCHA Enterprise configuration
   */
  public getRecaptchaEnterpriseConfig() {
    return {
      siteKey: firebaseConfig.recaptchaEnterpriseConfig?.siteKey,
      useEnterprise:
        firebaseConfig.recaptchaEnterpriseConfig?.useEnterprise || false,
      domain: window.location.hostname,
      trustSignals: this.getTrustSignalsForRecaptcha(),
    };
  }

  /**
   * Compile trust signals for reCAPTCHA scoring
   */
  private getTrustSignalsForRecaptcha() {
    try {
      return {
        loginCount: localStorage.getItem("login_count") || "0",
        consecutiveLogins:
          localStorage.getItem("consecutive_successful_logins") || "0",
        interactionScore: localStorage.getItem("user_interaction_score") || "0",
        deviceType: localStorage.getItem("device_type") || "unknown",
        browserType: localStorage.getItem("browser_type") || "unknown",
        humanBehavior:
          localStorage.getItem("human_behavior_detected") === "true",
        domainTrustLevel: localStorage.getItem("domain_trust_level") || "0",
        lastSuccessfulAuth: localStorage.getItem("auth_last") || null,
      };
    } catch (e) {
      return {};
    }
  }
}

// Export the singleton instance
const firebaseInstance = Firebase.getInstance();

// Setup authentication persistence with enhanced error handling
setPersistence(firebaseInstance.auth, browserLocalPersistence)
  .then(() => {
    // Record successful persistence setup
    localStorage.setItem("auth_persistence_ready", "true");
  })
  .catch((error) => {
    console.error("❌ Error setting auth persistence:", error);
    localStorage.setItem("auth_persistence_error", error.code || "unknown");
  });

export const auth = firebaseInstance.auth;
export const googleProvider = new GoogleAuthProvider();

// Configure Google provider for better user experience
googleProvider.setCustomParameters({
  prompt: "select_account", // Always show account selection
  hl: "en", // Set language
});

/**
 * Enhanced Google Sign-in with better error handling and trust signals
 */
export const signInWithGoogle = async (): Promise<UserCredential | null> => {
  try {
    // Pre-flight trust signal recording
    localStorage.setItem("google_signin_attempt", new Date().toISOString());

    const result = await signInWithPopup(auth, googleProvider);

    // Record successful Google auth with enhanced data
    if (result.user?.email) {
      firebaseInstance.recordSuccessfulAuth("google", result.user.email);

      // Additional Google-specific trust signals
      localStorage.setItem("google_signin_success", "true");
      localStorage.setItem("google_account_verified", "true");
    }

    return result;
  } catch (error: any) {
    console.error("Google Sign-In Error:", error);

    // Record failed attempt for learning
    localStorage.setItem("google_signin_last_error", error.code || "unknown");
    localStorage.setItem(
      "google_signin_last_error_time",
      new Date().toISOString()
    );

    return null;
  }
};

/**
 * Enhanced phone auth success recording
 */
export const recordPhoneAuthSuccess = (phoneNumber: string): void => {
  firebaseInstance.recordSuccessfulAuth("phone", phoneNumber);

  // Additional phone-specific tracking
  localStorage.setItem("phone_auth_success", "true");
  localStorage.setItem("phone_verified", "true");
  localStorage.setItem("sms_verification_working", "true");
};

// Export enhanced Firebase instance
export default firebaseInstance;
